let marker_archive_filters = ( function( $ ) {

	let $filters,
		base_url,
		anim_speed = 400;

	let _init = function() {
		$filters = $( '#marker-archive .filters' );
		base_url = $( '#marker-archive .filter-bar' ).data( 'base-url' );

		if ( $filters.length > 0 ) {
			_setup_filters();
		}
	};

	let _setup_filters = function() {
		$filters.find( '.filter-group' ).each( function( index, item ) {
			_setup_filter_group( $( item ) );
		} );

		_setup_responsive_toggle();
	};

	let _setup_filter_group = function( $group ) {
		$group.find( 'a.filter-group-title' ).on( 'click', function( e ) {
			e.preventDefault();
			_toggle_filter_panel( $group );
		} );

		$group.find( 'form' ).on( 'submit', function( e ) {
			e.preventDefault();
			_submit_form( $( this ).closest( 'form' ) );
		} );
	};

	let _setup_responsive_toggle = function() {
		$filters.find( 'a.toggle-responsive-panel' ).on( 'click', function( e ) {
			e.preventDefault();

			if ( $filters.find( '.responsive' ).hasClass( 'animating' ) ) {
				return
			}

			$filters.find( '.responsive' ).addClass( 'animating' );

			if ( ! $filters.find( '.responsive' ).hasClass( 'open' ) ) {
				$filters.find( '.responsive' ).removeClass( 'closed' );
				$filters.find( '.responsive' ).addClass( 'open' );
				$filters.find( '.responsive .responsive-toggle-panel' ).slideDown( anim_speed );

				setTimeout( function() {
					$filters.find( '.responsive' ).removeClass( 'animating' );
				}, anim_speed );
			} else  {
				$filters.find( '.responsive' ).removeClass( 'open' );
				$filters.find( '.responsive' ).addClass( 'closed' );
				$filters.find( '.responsive .responsive-toggle-panel' ).slideUp( anim_speed );

				setTimeout( function() {
					$filters.find( '.responsive' ).removeClass( 'animating' );
				}, anim_speed );
			}
		});
	};

	let _submit_form = function( $form ) {
		let query_arg     = $form.data( 'query-arg' ),
			$checked      = $form.find( 'input[type="checkbox"]:checked' ),
			new_vars      = [];

		$checked.each( function( index, item ) {
			let $item = $( item );
			new_vars[ index ] = $item.val();
		} );

		_insert_query_param( query_arg, new_vars.join( ',' ) );

	};

	let _insert_query_param = function( key, value ) {
		key   = encodeURI( key );
		value = encodeURI( value );

		let key_value_pair = document.location.search.substr( 1 ).split( '&' );

		let i = key_value_pair.length,
			query_var;

		while ( i-- ) {
			query_var = key_value_pair[ i ].split( '=' );

			if ( query_var[0] === key ) {
				query_var[1]        = value;
				key_value_pair[ i ] = query_var.join( '=' );
				break;
			}
		}

		if ( i < 0 ) {
			key_value_pair[ key_value_pair.length ] = [ key, value ].join('=');
		}

		let query_string = document.location.search = key_value_pair.join( '&' );

		document.location.href = base_url + '?' + query_string;
	};

	let _toggle_filter_panel = function( $group ) {
		if ( $group.hasClass( 'animating' ) ) {
			return;
		}

		$group.addClass( 'animating' );

		if ( ! $group.hasClass( 'open' ) ) {
			_open_filter( $group );
		} else {
			_close_filter( $group );
		}
	};

	let _close_filter = function( $group ) {
		$group.removeClass( 'open' );
		$group.addClass( 'closed' );
		$group.find( '.toggle-panel' ).slideUp( anim_speed );

		setTimeout( function() {
			$group.removeClass( 'animating' );
		}, anim_speed );
	};

	let _open_filter = function( $group ) {
		$group.removeClass( 'closed' );
		$group.addClass( 'open' );
		$group.find( '.toggle-panel' ).slideDown( anim_speed );

		setTimeout( function() {
			$group.removeClass( 'animating' );
		}, anim_speed );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = marker_archive_filters;